import React from "react";
import { connect } from "react-redux";
import { Marker, LayerGroup } from "react-leaflet";
import { BookmarkIcon } from "./Icons";
import { selectBookmark } from "redux/actions/index";
import { getCoordsAtTimestamp } from "components/util/GeometryUtilsV2";
import { routeGeomSelector } from "redux/selectors";

class BookmarkMarkers extends React.PureComponent {
    renderBookmarkMarkers = () => {
        const markerIconToUse = BookmarkIcon;
        const markers = [];

        if (this.props.bookmarks.length) {
            this.props.bookmarks.forEach((bookmark, index) => {
                const coords = getCoordsAtTimestamp(bookmark.image_timestamp, this.props.geometryData);
                if (coords !== null) {
                    let startCoords = [coords[1], coords[0]];
                    markers.push(
                        <Marker
                            position={startCoords}
                            onClick={() => this.onBookmarkClick(bookmark)}
                            icon={markerIconToUse}
                            key={index}
                        />,
                    );
                }
            });
        }
        return markers;
    };

    onBookmarkClick = (bookmark) => {
        this.props.dispatch(selectBookmark(bookmark.id));
    };

    render() {
        return <LayerGroup>{this.renderBookmarkMarkers()}</LayerGroup>;
    }
}

const mapStateToProps = (state) => {
    return {
        bookmarks: state.railInspection.bookmarks || [],
        geometryData: routeGeomSelector(state),
    };
};

export default connect(mapStateToProps)(BookmarkMarkers);
